import sendRequest from "@ecom/ui/utils/sendRequest"
import { HALVA_API_BASE_URL } from "../../../helpers/api"

export type Shop = {
  id: number
  brand: string
  icon_url: string
  partner_site_url: string
  period: number
  urlName: string
}

interface Response {
  errorCode: number
  result: Shop[]
  status: number
}

export default function fetchShops(offset = 0, limit = 30): Promise<Shop[]> {
  return sendRequest(`${HALVA_API_BASE_URL}/v2/halva/shop`, {
    limit,
    offset,
  }).then((res: Response) => {
    if (res.status === 1) {
      return res.result
    }
    throw new Error("Fetch partners failed")
  })
}
